"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ReceiptFilled = function ReceiptFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.736 2.06a.5.5 0 00-.513.024l-1.259.839-1.74-.87a.5.5 0 00-.448 0L14 2.941l-1.776-.888a.5.5 0 00-.448 0L10 2.941l-1.776-.888a.5.5 0 00-.448 0l-1.74.87-1.259-.839A.5.5 0 004 2.5v19a.5.5 0 00.777.416l1.259-.839 1.74.87a.5.5 0 00.448 0L10 21.059l1.776.888a.5.5 0 00.448 0L14 21.059l1.776.888a.5.5 0 00.448 0l1.74-.87 1.259.839A.5.5 0 0020 21.5v-19a.5.5 0 00-.264-.44zM7.5 6h9a.5.5 0 010 1h-9a.5.5 0 010-1zm0 3h9a.5.5 0 010 1h-9a.5.5 0 110-1zm5 7h-5a.5.5 0 110-1h5a.5.5 0 010 1zm0-3h-5a.5.5 0 110-1h5a.5.5 0 010 1zm3.5 5.025v.475a.5.5 0 01-1 0v-.463a2.192 2.192 0 01-1.052-.56.5.5 0 01.7-.711 1.176 1.176 0 001.193.268.576.576 0 00.356-.6c0-.293-.191-.424-.8-.7-.547-.241-1.3-.572-1.3-1.442a1.4 1.4 0 01.884-1.282l.019.003V12.5a.5.5 0 011 0v.472a1.742 1.742 0 01.752.437.5.5 0 01-.7.711.6.6 0 00-.68-.18.411.411 0 00-.269.36c0 .186.174.3.7.527.558.247 1.4.619 1.4 1.611A1.482 1.482 0 0116 18.025z",
    fill: "currentColor"
  })));
};

var _default = ReceiptFilled;
exports["default"] = _default;